module.exports = __webpack_public_path__ + "img/08_WebApp_Pappyon.e743584b.jpg";